export const PROFILE_PICTURE_STORAGE_ROOT = "profile-pictures";

export function sanitizeProfilePictureOwnerId(ownerId) {
  return String(ownerId || "")
    .trim()
    .replace(/[^a-zA-Z0-9:_-]/g, "");
}

export function sanitizeProfilePictureUserId(userId) {
  return String(userId || "")
    .trim()
    .replace(/[^a-zA-Z0-9_-]/g, "");
}

export function sanitizeProfilePictureExtension(fileExtension = "jpg") {
  return String(fileExtension || "jpg").replace(/[^a-zA-Z0-9]/g, "") || "jpg";
}

export function buildProfilePictureStoragePath({ ownerId, userId, fileExtension = "jpg", now = Date.now } = {}) {
  const normalizedOwnerId = sanitizeProfilePictureOwnerId(ownerId);
  const normalizedUserId = sanitizeProfilePictureUserId(userId);
  const normalizedExtension = sanitizeProfilePictureExtension(fileExtension);

  if (!normalizedOwnerId) {
    throw new Error("Profile picture owner identity is required.");
  }
  if (!normalizedUserId) {
    throw new Error("Profile picture user id is required.");
  }

  return `${PROFILE_PICTURE_STORAGE_ROOT}/${normalizedOwnerId}/${normalizedUserId}-avatar-${now()}.${normalizedExtension}`;
}

export async function resolveProfilePictureOwnerId({ cognitoId, fetchAuthSessionImpl } = {}) {
  const session = typeof fetchAuthSessionImpl === "function" ? await fetchAuthSessionImpl() : null;
  const identityId = sanitizeProfilePictureOwnerId(session?.identityId);
  if (identityId) return identityId;

  const fallback = sanitizeProfilePictureOwnerId(cognitoId);
  if (fallback) return fallback;

  throw new Error("Profile picture owner identity is required.");
}
